import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';

class EditSection extends Component {
	
	constructor(props){
		super(props);
		this.state = {
			id : '',
			clsname : '',
			desc : '',
			code : '',
			attper : '',
			atttype : '',
			days : '',
			syllname : '',
			_message : '',
			value : '',
			alertClass :'',
			isHidden : true,
			posts : []
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.back = this.back.bind(this);
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		
		if(this.state.cls && this.state.secname && this.state.noofstud){
			
			PostData('section/update',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Section Updated Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("subform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	componentWillMount(){
		
		this.getclass();
		this.getdetails();
	}
	
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	getdetails(){
		$("#showLoader").show();
		GetData('section/getsectionbyid/'+this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					cls : res[0]['class'],
					secname : res[0]['section'],
					sdate : res[0]['startdate'],
					edate : res[0]['enddate'],
					noofstud: res[0]['noofstudent']
				});
			}
		});
	}
	
	/** redirect to Section **/
	back(e){
		
		this.setState({_redirect :true});
	}
	
  render() {
	 
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/academic/section' />);
	}
	
	var items = this.state.posts;
	
    return (
		<div className="animated fadeIn">
		  <div className={this.state.alertClass}>
			{this.state._message}
		  </div>
			<Row>
			  <Col md="12">
				<Card>
				  <form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Edit Section</strong>
						<span className="pull-right">
							<Button outline color="primary" onClick={this.back}>Back</Button>
						</span>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
							  <select name="cls" className="form-control" required onChange={this.onChange} value={this.state.cls} >
								<option value="">Select</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.class}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Section <span className="text-danger">*</span></Label>
							  <Input type="text" name="secname" required onChange={this.onChange} value={this.state.secname} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Start Date</Label>
							  <Input type="date" name="sdate" onChange={this.onChange} value={this.state.sdate} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">End Date</Label>
							  <Input type="date" name="edate" onChange={this.onChange} value={this.state.edate} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Maximum Number of Students <span className="text-danger">*</span></Label>
							  <Input type="text" name="noofstud" required onChange={this.onChange} value={this.state.noofstud} />
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	);
  }
}

export default EditSection;



// WEBPACK FOOTER //
// ./src/academic/Section/EditSection.js